'use strict'

var config, service, planning;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  planning = config.VUE_APP_MOL_S_PLANNING
}

async function cicleSync(multiplo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${planning}/cicleSync`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ multiplo })
    })
    return await response.json()
  } catch (error) {
    return null
  }
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${planning}/mode`)
    const result = await response.json()
    if (result.status === 404) {
      return defaultRunMode()
    }
    return result
  } catch {
    return defaultRunMode()
  }
}

function defaultRunMode() {
  return {
    modulo: 'APPUNTAMENTI',
    locale: '---',
    remote: '---',
    versione: '---',
    health: '---'
  }
}

async function getAppuntamenti(data) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${planning}/search?dataUx=${data.valueOf()}`) // convert in millisecondi...
  return await response.json()
}

async function getAppuntamento(appuntamentoId) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${planning}/${appuntamentoId}`)
  return await response.json()
}

async function creaAppuntamento(appuntamento) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${planning}/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(appuntamento)
  })
  return await response.json()
}

async function modificaAppuntamento(appuntamentoId, appuntamento) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${planning}/${appuntamentoId}/update`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(appuntamento)
  })
  return await response.json()
}

async function aggiornaInfoAcquisto(appuntamentoId, infoAcquisto) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${planning}/${appuntamentoId}/update/acquisto`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(infoAcquisto)
  })
  return await response.json()
}

export default {
  cicleSync,
  getRunMode,
  getAppuntamenti,
  getAppuntamento,
  creaAppuntamento,
  modificaAppuntamento,
  aggiornaInfoAcquisto
}
